import axios from 'axios';

import { OfdFeedProgram } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/feed-programs.type';

// GET: Active fish group feed strategies for a site
// /ewosapi/v1/recommendations/fish-groups/feed-strategies?globalSiteId=${globalSiteId}
export const getOfdFeedPrograms = async (globalSiteId: string): Promise<OfdFeedProgram[]> => {
  const res = await axios.get<OfdFeedProgram[]>(
    `/ewosapi/v1/recommendations/fish-groups/feed-strategies?globalSiteId=${globalSiteId}`
  );
  return res.data;
};
